import React, { useEffect, useState } from "react";
import { Table, Button, Popover, Input, Popconfirm } from "antd";
import icons from "Common/Icons";
import utils from "utils";
import { CONSTANTS } from "../utils/constant";
import SubmitButton from "../Pages/Patient/SubmitButton"

function TableMedicineList(props) {
  const [columns, setColumns] = useState([]);
  const [med_ids,setMedIds]=useState([]);
  const [table_data, setTableData] = useState([]);
  const [commentField,setCommentField] = useState(props.comments || "");
  const [prescription_saved,setPrescriptionSaved]= useState("");
  useEffect(() => {    
    if (table_data.length > 0) {
      setTableData([...table_data, props.update_medicine[0]]);
     } 
     else {
     setTableData(props.update_medicine);
    }
  }, [props.update_medicine]);

  useEffect(()=>{
    setCommentField(props.comments||"")
  },[props.comments])

  useEffect(()=>{
    setPrescriptionSaved(props.prescription_comments_saved||"")
  },[props.prescription_comments_saved])
  useEffect(() => {
    let columns = [
      {
        title: `S.No.`,
        width: "2%",
        key: "index",
        align: "center",
        render: (data, record, index) => <span>{index + 1}</span>,
      },
      {
        title: (
          <div style={{ textAlign: "center" }}>
            <p style={{ margin: "0px auto" }}>{CONSTANTS.MED_NAME}</p>
            {props.prescription_type == "ayurveda" ? (
              <p style={{ margin: "0px auto" }}>({CONSTANTS.MED_ADJUVANT})</p>
            ) : (
              ""
            )}
          </div>
        ),
        width: "8%",
        key: "name",
        align: "center",
        render: (data) => (
          <>
            {data?.medicine || data?.drug_name}
            <span></span>
          </>
        ),
      },
      {
        title: `${CONSTANTS.MED_BRAND_NAME}`,
        width: "5%",
        key: "date",
        align: "center",
        render: (data) => <span>{data?.brand || data?.brand_name}</span>,
      },
      {
        title: `${CONSTANTS.MED_FORM}`,
        width: "4%",
        key: "date",
        align: "center",
        render: (data) => <span>{data?.form}</span>,
      },

      {
        title: `${CONSTANTS.MED_DOSAGE}`,
        width: "3%",
        key: "date",
        align: "center",
        render: (data) => <span>{data?.dosage}</span>,
      },
      {
        title: `${CONSTANTS.MED_ROUTE} `,
        width: "5%",
        key: "date",
        align: "center",
        render: (data) => <span>{data?.route}</span>,
      },
      {
        title: `${CONSTANTS.MED_FREQUENCY}`,
        width: "8%",
        key: "date",
        align: "center",
        render: (data) => (
          <>
            {data?.frequency.includes("-")
              ? data?.frequency
              : data?.frequency.split("")?.join("-")}
          </>
        ),
      },
      {
        title: `${CONSTANTS.MED_DURATION}`,
        width: "4%",
        key: "date",
        align: "center",
        render: (data) => (
          <span>
            {data?.duration?.split(" ")[0] +
              " " +
              data?.duration?.split(" ")[1]}
          </span>
        ),
      },
      {
        title: `${CONSTANTS.MED_INSTRUCTION}`,
        width: "2%",
        key: "date",
        align: "center",
        render: (data, record, index) => (
          <>
            {record?.instruction ? (
              <Popover id="prescription-instruction-popover" content={record.instruction} title="Instruction">
                <img
                  style={{ cursor: "pointer", height: "25px" }}
                  src={icons.instruction}
                />
              </Popover>
            ) : null}
          </>
        ),
      },
      {
        width: "1%",
        align: "center",
        render: (data, record, index) => (
          <Button
            disabled={props.on_edit}
            onClick={() => {
              onRemoveMedicine(record, index,false);
                props.onEditMedicine(record, index);
            }}
            icon={
              <img
                src={icons.edit_icon}
                // style={{ cursor: "pointer" }}
              />
            }
          />
        ),
      },
      {
        width: "1%",
        key: "date",
        align: "center",
        render: (data, record, index) => (
          <Button
            disabled={props.on_edit}
            onClick={() => {
              onRemoveMedicine(record, index,"clear");
            }}
            icon={
              <img
                src={icons.clear_all}
                // style={{ cursor: "pointer" }}
              />
            }
          />
        ),
      },
    ];
    columns = props?.is_prescription_report ?  columns.slice(0,-2) : columns ;
    setColumns(columns);
  }, [props.on_edit, props?.is_prescription_report]);

  const onRemoveMedicine = (record, index,col) => {
    setTableData((table_data) => {
      let temp=table_data.filter((item, i) => i !== index);
      if(temp.length==0 ){
        props.onRemoveMedicine(record,index);
      }   
       return temp
    });
      if(col=="clear"){
      props.onRemoveFormMed(record,"remove_med");
      }
   
  };
 
  return (
    <>
      <Table
        style={{ margin: "20px 0px" }}
        pagination={false}
        columns={columns}
        dataSource={table_data}
      />
      <div style={{marginBottom:"10px"}}><div style={{marginBottom:"10px",fontSize:"14px"}}>{CONSTANTS.CLINICIAN_COMMENTS}</div>
      <Input.TextArea  value={commentField} onChange={(e)=>{ setCommentField(e.target.value)}} rows={4} placeholder="Type here"/>
      </div>
      {!props?.is_prescription_report && (
        <div className="save-prev-btn">
        {
        (table_data.length == 0 && commentField.trim() && !prescription_saved)? <Popconfirm placement="topRight"
        title={`${CONSTANTS.CONFRIM_PRESCRIPTION_TYPE} ${utils.ConvertToPascalCase(props.prescription_type)}`}
        description={`${CONSTANTS.CONFRIM_PRESCRIPTION_TYPE_DESCRIPTION}`}
        okText="Yes"
        cancelText="No"
        onCancel ={()=>{props.onPopConfirmClose()}}
        onConfirm = {() => { props.onSave(table_data,commentField)}}
      ><SubmitButton className={"confirm-btn"} label={"Save and Preview"} loading={props.isSaving} disabled={props.on_edit || (table_data.length == 0 && commentField.trim().length == 0)}/></Popconfirm> :
        <SubmitButton className={"confirm-btn"} label={"Save and Preview"} loading={props.isSaving} onClick={() => { 
          props.onSave(table_data,commentField)}} disabled={props.on_edit || (table_data.length == 0 && commentField.trim().length == 0)}/>}
        </div>
      )}
    </>
  );
}

export default TableMedicineList;
